<template>
    <div class="render">
        <app-page v-bind:editor-mode="false"></app-page>
        <div class="status-pixel" :class="getLoadClass" :data-rendered-time="getLoadTime"></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Page from '@/components/assorted/Page.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-page': Page
    },
    methods: {
        ...mapActions(['updateHeadTitle', 'updateHeadDescription'])
    },
    computed: {
        ...mapGetters([
            'getActivePageMetaTitle',
            'getActivePageMetaDescription',
            'getActivePageId'
        ]),
        getLoadClass() {
            return 'loaded-' + this.getActivePageId;
        },
        getLoadTime() {
            return (
                new Date().getFullYear() +
                '-' +
                ('0' + (new Date().getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + new Date().getDate()).slice(-2) +
                ' ' +
                ('0' + new Date().getHours()).slice(-2) +
                ':' +
                ('0' + new Date().getMinutes()).slice(-2) +
                ':' +
                ('0' + new Date().getSeconds()).slice(-2)
            );
        }
    },
    created() {
        this.updateHeadTitle(this.getActivePageMetaTitle);
        this.updateHeadDescription(this.getActivePageMetaDescription);
    },
    updated() {
        this.updateHeadTitle(this.getActivePageMetaTitle);
        this.updateHeadDescription(this.getActivePageMetaDescription);
    }
};
</script>
